import { Caselet, delete_user_data_from_client_side, getInitials } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import Avatar from "../../design-system/Avatar";
import { Card, CardHeader, CardBody } from "@material-tailwind/react";
import { EyeIcon } from "@heroicons/react/24/solid";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../state/store";
// import { getCaseletFileInfo, getUnPublishedCaseletFileInfo, savePublishedCaselet, saveUnpublishedCaselet } from "../../api";
import { initializeCaselet } from "../../pages/caselet/caseletSlice";
import style from "./CaseletItem.module.css";
import ErrorBoundary from "../../utils/ErrorBoundry";
import useRefreshToken from "../../utils/useRefreshToken";
import { getCaseletFileInfo, getUnPublishedCaseletFileInfo, savePublishedCaselet, saveUnpublishedCaselet } from "../../api/axiosApi";
type CaseletItemProps = {
    caselet: Caselet;
};
const CaseletHeader = ({ caselet }: CaseletItemProps) => {
    function getNumberOfDaysSinceTimestamp(timestamp: any): string {
        const inputDate = new Date(timestamp * 1);

        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthIndex = inputDate.getMonth();
        const day = inputDate.getDate();
        const year = inputDate.getFullYear();

        return `${months[monthIndex]} ${day}, ${year}`;
    }
    const author_name = caselet.authorName ? caselet.authorName : "Jhon Doe";
    const view_number = caselet.view !== undefined ? caselet.view : 0;
    const initials = getInitials(author_name);
    return (
        <div className={`${style.header} p-1 text-gray-700`}>
            <div className="flex items-center">
                <Avatar initials={initials} className="mr-2" fullName={author_name} />
            </div>
            <span className={`justify-self-center truncate w-full max-w-full text-gray-500`}>{getNumberOfDaysSinceTimestamp(caselet.id)}</span>
            <h2 className={`justify-self-center font-title truncate w-full max-w-full`} title={caselet.title}>
                {caselet.title}
            </h2>
            <div className="flex items-center justify-end font-medium text-gray-500">
                <EyeIcon className="h-6 pr-1 text-gray-500" /> {view_number}
            </div>
        </div>
    );
};

const CaseletBody = ({ caselet }: CaseletItemProps) => {
    // console.log("CaseletBody: ",caselet )
    return (
        <div>
            <div className="outcome">
                <h3 className="font-title">Outcome</h3>
                <p className="card-content">{caselet.summary.outcome}</p>
            </div>
            <div className="summary mt-4">
                <h3 className="font-title">Summary</h3>
                <p className="card-content">{caselet.summary.scenario}</p>
            </div>
        </div>
    );
};

const CaseletItem = ({ caselet }: CaseletItemProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const refreshToken = useRefreshToken();
    const navigate = useNavigate();
    // console.log("caselet in item: ", caselet)
    const handleClick = async () => {
        console.log("caselet true/false: ", location.pathname.includes("unpublished_caselets"));
        try {
            // const access_token = localStorage.getItem("access_token");

            // if (isTokenExpired(access_token)) {
            //     await refreshToken();
            // }
            let caseletInfoResponse: Response | undefined | any;

            if (caselet.published === undefined || caselet.published) {
                caseletInfoResponse = await getCaseletFileInfo(caselet.id);
            } else if (!caselet.published) {
                caseletInfoResponse = await getUnPublishedCaseletFileInfo(caselet.id);
            }

            if (caseletInfoResponse) {
                // if (caseletInfoResponse.status === 401 || caseletInfoResponse.status === 422) {
                //     delete_user_data_from_client_side()
                //     navigate("/user_login");
                // }
                // if (!caseletInfoResponse.ok) {
                //     // setStatusCode(caseletInfoResponse.status);
                //     throw new Error(`${caseletInfoResponse.status}`);
                // }
                const caseletInfo = await caseletInfoResponse.data;
                if (caseletInfo.view !== undefined) {
                    caseletInfo.view = caseletInfo.view + 1;
                } else {
                    caseletInfo.view = 1;
                }
                if (caseletInfo.published === undefined || caseletInfo.published) {
                    caseletInfo.published = true;
                    savePublishedCaselet(caseletInfo.id, caseletInfo);
                } else if (!caseletInfo.published) {
                    saveUnpublishedCaselet(caseletInfo.id, caseletInfo);
                }
                dispatch(initializeCaselet(caseletInfo));
            } else {
                console.error("caseletInfoResponse is undefined");
            }
        } catch (error) {
            // setError(true);
            console.error(`Failed to fetch caselet data `, error);
        }
        if (caselet.published === undefined || caselet.published) {
            navigate(`/caselets/${caselet.id}`);
        } else if (!caselet.published) {
            navigate(`/unpublished-caselets/${caselet.id}`);
        }
    };

    return (
        <Card onClick={handleClick} className="mt-6 hover:cursor-pointer  pb-4">
            <ErrorBoundary fallback="Error Occurred">
                <CardHeader className="relative">
                    <CaseletHeader caselet={caselet} />
                </CardHeader>
                <CardBody className="p-2">
                    <CaseletBody caselet={caselet} />
                </CardBody>
            </ErrorBoundary>
        </Card>
    );
};

export default CaseletItem;
